// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UTMG","title":"styles_title__1XjCQ"};